import { useCallback, useEffect, useState } from 'react';
import { DocumentFilters } from '~/components/ui/tables/ag/documentsTable/DocumentFilterPanel';
import { IRowNode } from 'ag-grid-enterprise';
import { FundDocument } from '~/api/def/endpoints/fundEndpoint';

/** Filter table data based on external filters
 * only applicable to the document table
 * hence TODO: move to document table folder or refactor to be more generic
 * */
export const useFilterTable = <T extends Record<string, unknown>>(
  tableData: T[],
) => {
  const [filteredData, setFilteredData] = useState<T[]>(tableData);
  const [externalFilters, setExternalFilters] = useState<DocumentFilters>({});
  const [fundNameSearch, setFundNameSearch] = useState<string>('');

  /** filter fn for the external filter on fundName
   * */
  const doesExternalFilterPass = useCallback(
    (node: IRowNode<FundDocument>) => {
      return !!node.data?.originalName
        .toLocaleLowerCase()
        .includes(fundNameSearch?.toLowerCase());
    },
    [fundNameSearch],
  );

  useEffect(() => {
    const filteredData = tableData.filter((row) => {
      let showRow = true;
      // console.log("externalFilters", externalFilters);
      for (const key in externalFilters) {
        // Object.entries(externalFilters).every(([key, value]) => {
        if (
          key === 'type' &&
          externalFilters[key] &&
          row['type'] !== externalFilters[key]
        ) {
          showRow = false;
        }
        if (key === 'status') {
          console.log('row', row);
          switch (externalFilters[key]) {
            case 'All':
              break;
            case 'Dead':
              row['liveness'] !== false ? (showRow = false) : null;
              break;
            case 'Live':
              row['liveness'] !== true ? (showRow = false) : null;
              break;
          }
        }
      }
      return showRow;
    });
    setFilteredData(filteredData as T[]);
  }, [tableData, externalFilters]);

  return {
    filteredData,
    externalFilters,
    setExternalFilters,
    setFundNameSearch,
    fundNameSearch,
    doesExternalFilterPass,
  } as const;
};
